import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, Renderer2 } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import * as moment from "moment";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT as KEYTEXT } from "../../../text_control";
import { errMsg } from "../../../text_control/error-msg";
import { BTN } from "../../../text_control/text_button";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { _getStorage } from "../../../utils/local-storage";
import { ModalSaveDraftComponent } from "../modal-save-draft/modal-save-draft.component";
import { TaxInvoiceSaveComponent } from "../tax-invoice-save/tax-invoice-save.component";
export interface Fruit {
  abb: string;
}

@Component({
  selector: "app-tax-invoice-search-buy-product",
  templateUrl: "./tax-invoice-search-buy-product.component.html",
  styleUrls: ["./tax-invoice-search-buy-product.component.scss"],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: "en-GB" }],
})
export class TaxInvoiceSearchBuyProductComponent implements OnInit {
  @Input() public appAutoFocus: boolean;
  showtable = false;
  datacustomer: any = [];
  dataaddress: any;
  radio_group = "";
  datalist: any = {};
  datatest = [];
  buyer_type = "";
  showbtn = true;
  showbranch = true;
  showinputremark = false;
  showOderNo = false;
  orderNo: any = "";
  isShowBranchNo = true;
  remark: any = "";
  text: any;
  textBTN: any;
  textTB: any;
  receiptDate: Date = new Date();
  today: Date = new Date();

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  listPriority = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [];
  headerNewService: any;
  is_saveDraft = false;

  constructor(
    public modalController: ModalController,
    public storage: Storage,
    private appService: AppService,
    public apiservice: ApiserviceService,
    public http: HttpClient,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public route: Router,
    private renderer: Renderer2,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text = KEYTEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE;
    dateAdapter.setLocale("en-GB");
  }

  actice = 3;
  getValue: any;
  ngOnInit() {}

  ionViewWillLeave() {
    this.showtable = false;
    this.datacustomer = [];
    this.dataaddress = "";
    this.radio_group = "";
    this.datalist = {};
    this.datatest = [];
    this.buyer_type = "";
    this.showbtn = true;
    this.showbranch = true;
  }

  focusMyInput() {
    this.renderer.selectRootElement("#myInput").focus();
  }
  getSortPriority() {
    const req = {
      bu: this.userBu,
      loc: this.userLoc,
    };

    this.apiservice
      ._post(this.apiservice.apiUrl + this.apiservice.getSortPriority, req)
      .then((res) => {
        console.log("RES GET SORT PRIORITY =======:: ", res);
        if (res.statusCode === 200) {
          this.listPriority = res.data;
        }
      });
  }

  ionViewDidEnter() {
    this.checkfrut();
    // this.is_saveDraft = false;
    this.showtable = false;
    this.datasalesTicket = [];
    this.fruits = [];
    this.appService.setActive(3);
    this.getSortPriority();

    setTimeout(() => {
      var elem = this.renderer.selectRootElement("#myInput");
      this.renderer.listen(elem, "focus", () => {});
      this.renderer.listen(elem, "blur", () => {});
      elem.focus();
    }, 100);

    this.datacustomer = _getStorage(STORAGE.DATA_ABB);
    this.buyer_type = this.datacustomer.buyer_type;

    if (this.buyer_type === "0" || this.buyer_type === "2") {
      this.showbranch = false;
    } else {
      this.showbranch = true;
    }
    if (this.datacustomer != "object") {
      this.showbtn = true;
    }
    if (this.datacustomer.buyer_main_branch_no) {
      this.radio_group = this.datacustomer.buyer_main_branch_no;
    } else {
      this.radio_group = this.datacustomer.buyer_branch_no;
    }

    if (this.datacustomer.address_detail[0].type_addr === "1") {
      this.dataaddress = this.datacustomer.address_detail[0].addr_info;
    } else if (this.datacustomer.address_detail[0].type_addr === "2") {
      this.dataaddress = this.datacustomer.address_detail[0].addr_infoEN;
    }
  }

  async modalDraft() {
    const modal = await this.modalController.create({
      component: ModalSaveDraftComponent,
      cssClass: "my-custom-draft",
      componentProps: {
        company_name: this.datacustomer.buyer_company_name,
        buyer_id: this.datacustomer.buyer_id,
      },
    });
    console.log("dafda", modal);

    modal.onDidDismiss().then(async () => {});
    return await modal.present();
  }

  async presentModal() {
    this.appService.setActive(4);
    const modal = await this.modalController.create({
      component: TaxInvoiceSaveComponent,
      cssClass: "my-custom-class",
      componentProps: {
        data: this.numberABB,
        tpno: this.tpno === "0" ? true : false,
        buyer_id: this.datacustomer.buyer_id,
        email:
          this.buyer_type === "1"
            ? ""
            : this.datacustomer.address_detail[0].email || "",
        remark: this.remark,
        orderNo: this.orderNo,
        isShowBranchNo: this.isShowBranchNo,
        newService: this.headerNewService,
        receipt_date: moment(this.receiptDate).format("YYYY-MM-DD"),
      },
    });
    console.log("dafda", modal);

    modal.onDidDismiss().then(async () => {});
    return await modal.present();
  }

  searchABB: any = "";
  data_searchABB: any;
  data_total: any;
  datasalesTicket: any;
  numberABB: any;
  tpno = "0";
  count = 0;
  numberABB2: any = [];
  async search_ABB() {
    let isConfirm = false;
    let numberABB: any = [];
    let numberABB2 = [];
    for (let i of this.fruits) {
      numberABB.push(i.abb);
    }

    try {
      numberABB.forEach((i) => {
        if (i.indexOf("-") > -1) {
          numberABB2.push(
            `${Number(i.split("-")[0])}-${
              this.userBu.toUpperCase() == "PWB"
                ? i.split("-")[1].padStart(9, "0")
                : i.split("-")[1].padStart(6, "0")
            }`
          );
        } else {
          numberABB2.push(i);
        }
      });

      if (!isConfirm) {
        if (this.searchABB === "") {
          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: "กรุณาระบุเลขที่ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ",
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: (blah) => {},
              },
            ],
          });
          await alert.present();
        } else {
          if (this.showOderNo === true && numberABB2.length > 1) {
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              message: errMsg.errorLengthAbbOderNo,
              buttons: [
                {
                  text: "OK",
                  cssClass: "alertButton",
                  handler: (blah) => {
                    numberABB = numberABB.splice(0, 1);
                    this.fruits = this.fruits.slice(0, 1);
                  },
                },
              ],
            });
            await alert.present();
          } else if (numberABB2.length > 10) {
            const alert = await this.alertController.create({
              cssClass: "my-custom-class",
              message: errMsg.errorLengthAbb,
              buttons: [
                {
                  text: "OK",
                  cssClass: "alertButton",
                  handler: (blah) => {
                    numberABB = numberABB.splice(0, 10);
                    this.fruits = this.fruits.slice(0, 10);
                  },
                },
              ],
            });
            await alert.present();
          } else {
            isConfirm = true;
          }
        }
      }
    } catch (error) {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        message: errMsg.errorAbb,
        buttons: [
          {
            text: "OK",
            cssClass: "alertButton",
            handler: (blah) => {
              this.datasalesTicket = [];
              this.showtable = false;
              this.fruits = [];
              this.showbtn = true;
            },
          },
        ],
      });
      await alert.present();
    }

    this.numberABB = numberABB2;

    if (isConfirm) {
      let data = {
        searchABB: {
          bu: this.userBu,
          userid: this.userID,
          loc: this.userLoc,
          userSource: this.userSource,
          receiptno: numberABB2,
          tpno: this.tpno === "0" ? true : false,
          type: "",
          orderNo: this.orderNo,
          receipt_date: this.receiptDate
            ? moment(this.receiptDate).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
        },
      };

      console.log("======= REQ GET ABB ========", data);

      for await (const [index, item] of this.listPriority.entries()) {
        const header = {
          source_connection: item?.source_connection_id,
        };

        console.log("HEADER GET ABB ========:: ", header);
        try {
          const res = await this.apiservice._post(
            this.apiservice.apiUrl + this.apiservice.getABB,
            data,
            header
          );
          console.log("=========== res data searchABB =========== ", res);
          this.data_searchABB = res;
          if (res.statusCode === 200) {
            this.headerNewService = header;
            this.showtable = true;
            this.datasalesTicket = this.data_searchABB.data;
            return;
          } else if (res.statusCode === 204) {
            if (this.listPriority.length === index + 1) {
              // this.is_saveDraft = true;
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: res.statusMessage,
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      console.log("numberABB =======::: ", this.numberABB);
                      console.log("fruits =======::: ", this.fruits);

                      for (const item of res.data) {
                        const index: any = this.numberABB.findIndex(
                          (f) => String(f) === String(item.errorData)
                        );

                        console.log("filterAbb=====:: ", index);

                        if (index > -1) {
                          this.fruits.splice(index, 1);
                          this.numberABB.splice(index, 1);
                          if (
                            this.fruits.length === 0 ||
                            String(this.fruits) === ""
                          ) {
                            this.showbtn = true;
                          } else {
                            this.showbtn = false;
                          }
                        }
                      }
                      console.log("numberABB =======::: ", this.searchABB);
                      console.log("fruits =======::: ", this.fruits);
                    },
                  },
                ],
              });
              await alert.present();
            }
          } else {
            this.ErrorMsg(res.statusMessage);
            return;
          }
        } catch (error) {
          return;
          // this.ErrorMsg(errMsg.error);
        }
      }
    }
  }

  newservice(data) {
    console.log('========= START newservice ================')
    const header = {
      rtsnewservice: "rts-new-service",
    };
    this.apiservice
      ._post(this.apiservice.apiUrl + this.apiservice.getABB, data, header)
      .then(async (res: any) => {
        console.log("=========== res data searchABB =========== ", res);
        this.data_searchABB = res;
        if (res.statusCode === 200) {
          this.headerNewService = header;
          this.showtable = true;
          this.datasalesTicket = this.data_searchABB.data;
        } else if (res.statusCode === 204) {
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  async delitem(post, i) {
    const alert = await this.alertController.create({
      cssClass: "my-confirm-phone",
      message: "ต้องการลบรายการนี้ใช่หรือไม่",
      buttons: [
        {
          text: "ยกเลิก",
          role: "cancel",
          cssClass: "alertCancel",
          handler: (blah) => {},
        },
        {
          text: "ยืนยัน",
          cssClass: "alertCancel",
          handler: () => {
            const checkReceipt = post.salesTicket[0].receiptNo;
            const tpno = post.salesTicket[0].tpNo;
            let item = [];
            item = this.datasalesTicket;
            let index1 = this.datasalesTicket.indexOf(post);
            const index = this.numberABB.findIndex(
              (find) =>
                String(find) === String(checkReceipt) ||
                String(find) === String(tpno)
            );

            if (index > -1 || index1 > -1) {
              this.numberABB.splice(index1, 1);
              this.fruits.splice(index, 1);
              this.datasalesTicket.splice(index1, 1);
              if (this.fruits.length === 0 || String(this.fruits) === "") {
                this.showbtn = true;
              } else {
                this.showbtn = false;
              }
            }
            if (item.length < 1) {
              this.showtable = false;
            }
          },
        },
      ],
    });
    await alert.present();
  }

  async checkphone(e, n) {
    let phone = [];
    phone = this.searchABB;
    if (n == 1) {
      if (isNaN(this.searchABB) || e.key == " ") {
        this.searchABB = this.searchABB.slice(0, -1);
      }
    }
  }

  async checkbtn(e) {
    this.searchABB = e.target.value.match(/[0-9,-]*/);
    if (e.target.value.length > 1 || e.key === "Enter") {
      this.showbtn = false;
    } else {
      this.showbtn = true;
    }
    this.addDataAbb();
  }

  async addDataAbb() {
    if (this.showOderNo === true) {
      console.log("this.fruits======:: ", this.fruits);
      if (this.fruits.length > 1) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: errMsg.errorLengthAbbOderNo,
          buttons: [
            {
              text: "OK",
              cssClass: "alertButton",
              handler: (blah) => {
                this.fruits = this.fruits.splice(0, 1);
                this.fruits = this.fruits.slice(0, 1);
              },
            },
          ],
        });
        await alert.present();
      }
    } else {
      if (this.fruits.length > 10) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: errMsg.errorLengthAbb,
          buttons: [
            {
              text: "OK",
              cssClass: "alertButton",
              handler: (blah) => {
                this.fruits = this.fruits.splice(0, 10);
                this.fruits = this.fruits.slice(0, 10);
              },
            },
          ],
        });
        await alert.present();
      }
    }
  }

  add(e: MatChipInputEvent): void {
    console.log("this.fruits=====:: ", e);
    const input = e.input;
    const value = e.value;
    // Add our fruit
    if (value.trim()) {
      const isAlreadyHave = this.fruits.find(
        (item) => item.abb == value.trim()
      );
      if (!isAlreadyHave) {
        this.fruits.push({ abb: value.trim() });
      }
    }
    this.addDataAbb();

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(fruit: Fruit): void {
    console.log("fruit===>", fruit);
    console.log("numberABB========:: ", this.numberABB);
    console.log("datasalesTicket======:: ", this.datasalesTicket);
    let abb: any = fruit;
    let data = [];
    let databarcode: String = fruit.abb;
    data = this.datasalesTicket;
    if (databarcode.length > 16) {
      console.log(";;;;");
      const index2 = this.fruits.indexOf(fruit);
      if (index2 > -1) {
        this.fruits.splice(index2, 1);

        if (this.fruits.length === 0 || String(this.fruits) === "") {
          this.showbtn = true;
          this.showtable = false;
        } else {
          this.showbtn = false;
        }
      }
      if (this.datasalesTicket.length > 0) {
        const index1 = this.numberABB.findIndex((i) => i === fruit.abb);
        const index = this.datasalesTicket[0].salesTicket.findIndex(
          (i) => i.barcodeComplete === fruit.abb
        );

        if (index > -1) {
          this.numberABB.splice(index1, 1);
          this.fruits.splice(index, 1);
          this.datasalesTicket.splice(index, 1);
          if (this.fruits.length === 0 || String(this.fruits) === "") {
            this.showbtn = true;
            this.showtable = false;
          } else {
            this.showbtn = false;
          }
        }
      }
    } else if (this.numberABB?.length > 0) {
      for (const item of this.numberABB) {
        if (item.indexOf("-") > -1) {
          try {
            let temp_no: any = fruit.abb.split("-");
            let Abb: any = temp_no[0] + "-" + temp_no[1].padStart(6, "0");
            this.removeAbb(Abb);
          } catch {
            const index = this.fruits.indexOf(fruit);
            if (index > -1) {
              this.fruits.splice(index, 1);
            }
          }
        } else {
          this.removeAbb(item);
        }
      }
    } else {
      const index = this.fruits.indexOf(fruit);
      if (index > -1) {
        this.fruits.splice(index, 1);

        if (this.fruits.length === 0 || String(this.fruits) === "") {
          this.showbtn = true;
          this.showtable = false;
        } else {
          this.showbtn = false;
        }
      }
    }
  }

  removeAbb(Abb) {
    const index1 = this.numberABB.findIndex((i) => i === Abb);
    const index = this.datasalesTicket[0].salesTicket.findIndex(
      (i) => i.tpNo === Abb || i.receiptNo === Abb || i.barcodeComplete === Abb
    );

    if (index > -1 || index1 > -1) {
      this.numberABB.splice(index1, 1);
      this.fruits.splice(index1, 1);
      this.datasalesTicket.splice(index, 1);
      if (this.fruits.length === 0 || String(this.fruits) === "") {
        this.showbtn = true;
        this.showtable = false;
      } else {
        this.showbtn = false;
      }
    }
  }

  checkfruts(abb) {
    if (this.fruits.length > 1) {
      const index = this.fruits.findIndex((i) => i === abb);
      if (index > -1) {
        this.fruits.splice(index, 1);
        this.checkfrut();
      }
    } else {
      this.showbtn = true;
    }
  }

  checkfrut() {
    if (this.fruits.length > 1) {
      this.showbtn = false;
    } else {
      this.showbtn = true;
    }
  }
  checkremark(e) {
    this.remark = "";
    e.detail.checked == true
      ? (this.showinputremark = true)
      : (this.showinputremark = false);
  }
  checkOderNo(e) {
    this.orderNo = "";
    this.fruits = [];
    this.datasalesTicket = [];
    this.showtable = false;
    e.detail.checked == true
      ? (this.showOderNo = true)
      : (this.showOderNo = false);
  }

  gotoback() {
    this.route.navigate(["/tax-invoice-select"]);
    this.appService.setActive(2);
  }

  formatnumber(data) {
    return data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  Abbnumber(data: any) {
    let temp_no: any = data;
    if (temp_no) {
      temp_no = data.split("-");
      return temp_no[0] + "-" + temp_no[1].padStart(6, "0");
    }
  }
}
